/* @flow */

import React, { Children, cloneElement } from 'react';
import classNames from 'classnames';
import useSheet from '../../jss';
import FilterLabel from './FilterLabel';

type Props = {
  children?: React$Element<*>,
  className?: string,
  disabled?: boolean,
  itemClassName?: string,
  legend?: string,
  sheet: Object,
  style?: Object,
  scheme?: 'dark' | 'light',
};

const defaultProps = {
  children: undefined,
  className: undefined,
  disabled: false,
  itemClassName: undefined,
  legend: '',
  style: undefined,
  scheme: 'light',
};

function Fieldset({
  children,
  className,
  disabled,
  itemClassName,
  legend,
  sheet: { classes },
  style,
  scheme,
}: Props) {
  return (
    <div className={classNames(classes.fieldset, className)} style={style}>
      <FilterLabel disabled={disabled} scheme={scheme}>
        {legend}
      </FilterLabel>
      <div className={classes.items}>
        {Children.map(
          children,
          child =>
            (child ? (
              <div
                key={child.key}
                className={classNames(classes.item, itemClassName)}
                style={
                  !itemClassName
                    ? {
                        flexGrow: 1,
                        flexShrink: 1,
                      }
                    : null
                }
              >
                {cloneElement(child, { disabled })}
              </div>
            ) : null),
        )}
      </div>
    </div>
  );
}

Fieldset.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    fieldset: {
      flexGrow: 1,
      flexShrink: 1,
      paddingTop: 5,
      paddingBottom: 5,
    },
    items: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginLeft: -3,
      marginRight: -3,
    },
    item: {
      paddingTop: 5,
      paddingRight: 3,
      paddingBottom: 5,
      paddingLeft: 3,
    },
    [theme.mediaQuery.tabletLandscapeAndUp]: {
      fieldset: {
        flexBasis: '100%',
      },
      items: {
        flexWrap: 'wrap',
      },
    },
  };
}

export default useSheet(applyStyles)(Fieldset);
